import React, { useCallback } from 'react';
import {Button, Icon} from '@chakra-ui/react';
import { toaster } from '@/components/ui/toaster';
import { FaShareAlt } from 'react-icons/fa';

async function copyTextToClipboard(text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  try {
    const ok = document.execCommand('copy');
    if (!ok) throw new Error('execCommand copy failed');
  } finally {
    document.body.removeChild(ta);
  }
}

/**
 * Botón «Compartir perfil» unificado (pestaña Mi perfil, previsualización, perfil público / comunidad).
 */
const ShareProfileButton = ({ shareUrl = '', size = { base: 'sm', md: 'md' }, ...rest }) => {
  

  const handleClick = useCallback(async () => {
    if (!shareUrl) {
      toaster.create({
        title: 'Enlace no disponible',
        description: 'Espera a que cargue tu perfil o vuelve a iniciar sesión.',
        type: 'warning',
        duration: 4000,
        closable: true,
        position: 'top',
      });
      return;
    }
    try {
      await copyTextToClipboard(shareUrl);
      toaster.create({
        title: 'Enlace copiado',
        description: 'Pégalo donde quieras compartir el enlace al perfil público.',
        type: 'success',
        duration: 3000,
        closable: true,
        position: 'top',
      });
    } catch {
      toaster.create({
        title: 'No se pudo copiar',
        description: 'Intenta de nuevo o copia el enlace manualmente desde la barra de direcciones.',
        type: 'error',
        duration: 5000,
        closable: true,
        position: 'top',
      });
    }
  }, [shareUrl]);

  return (
    <Button
      type="button"
      colorPalette="purple"
      variant="outline"
      size={size}
      rounded="full"
      opacity={!shareUrl ? 0.55 : 1}
      {...rest}
      onClick={handleClick}><Icon asChild><FaShareAlt /></Icon>Compartir perfil
                </Button>
  );
};

export default ShareProfileButton;
